import React from "react";
import { Link, Outlet } from "react-router-dom";
import StepIndicator from "./StepIndicator";

const NewScanLayout = () => {
  return (
    <div className="new-scan-layout">
      <div className="wizard-layout-actions">
        <Link className="wizard-dashboard-link" to="/">← Back to Dashboard</Link>
      </div>
      <StepIndicator />
      <div className="step-content">
        <Outlet />
      </div>
    </div>
  );
};

export default NewScanLayout;
